import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { AppSettings } from 'app/app.settings';

@Component({
  selector: 'app-user-verify',
  templateUrl: './user-verify.component.html',
  styleUrls: ['./user-verify.component.css']
})
export class UserVerifyComponent implements OnInit {

	public message: string;
	public password: string;
	public rePassword: string;

	public isVerified = false;
	public isSetting = false;
	public isSettingFinished = false;

	public imgUrl: string = AppSettings.authLogoUrl;

	private token: string;
	constructor(
		private route: ActivatedRoute,
		private authService: AuthService
	) { }

	async setPw() {
		this.isSetting = true;
		try {
			await this.authService.updatePw(this.password, this.token, true);
			this.message = 'Your password is successfully updated!';
		} catch (err) {
			console.log(err);
			this.message = 'Failed to set password.';
		}
		this.isSetting = false;
		this.isSettingFinished = true;
	}
	async ngOnInit() {
		this.token = this.route.snapshot.queryParams['token'];
		if (!this.token) {
			this.message = 'Token Is Not Valid.';
			return;
		}
		this.message = 'Connecting...';
		try {
			await this.authService.activateUser(this.token);
			this.message = 'Your email is successfully activated! Please set a password.';
			this.isVerified = true;
		} catch (err) {
			console.log(err);
			this.message = 'Failed to activate user.';
		}
	}

}
